import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { combineClasses } from "../utilities/combineClasses.js";
import ThemeProvider_module from "./ThemeProvider.module.js";
const themeOverride = {};
const ThemeProvider = /*#__PURE__*/ forwardRef(({ className, style, ...props }, ref)=>/*#__PURE__*/ jsx("div", {
        className: combineClasses(ThemeProvider_module.defaultTheme, className),
        style: {
            ...themeOverride,
            ...style
        },
        ...props,
        ref: ref
    }));
ThemeProvider.displayName = 'ThemeProvider';
export { ThemeProvider };
